export default "__VITE_ASSET__BeKet4EC__"